/**
 * PROMPT-159: Entity Name Shortening Utility
 * 
 * Formats entity names for display in tables with consistent shortening rules
 */

/**
 * Format entity name according to PROMPT-159 rules
 * 
 * Rules (in order):
 * 1. Word-based shortening: If multiple words, show first 3-4 meaningful words
 * 2. Character limit: If exceeds 30 chars, trim and add "..."
 * 3. Short names: If ≤ 30 chars, display full name
 * 
 * @param {string} name - The full entity name
 * @returns {string} - The formatted entity name
 */
export const formatEntityName = (name) => {
  if (!name) return '';

  // Remove trailing abbreviations (anything after dash/hyphen)
  const cleanName = name.replace(/[-–].*$/, '').trim();
  
  // Split into words
  const words = cleanName.split(/\s+/);

  // RULE 1: Word-based shortening (preferred)
  // If entity name has multiple words, display first 3-4 meaningful words
  if (words.length > 4) {
    return words.slice(0, 4).join(' ');
  }

  // RULE 2: Character limit fallback
  // If name exceeds 30 characters, trim and add "..."
  if (name.length > 30) {
    return name.substring(0, 30) + '...';
  }

  // RULE 3: Short names (no change)
  // If name is ≤ 30 characters, display full name
  return name;
};

/**
 * Get the full entity name for tooltip display
 * 
 * @param {string} name - The full entity name
 * @returns {string} - The full entity name
 */
export const getFullEntityName = (name) => {
  return name || '';
};
